import { replace } from 'connected-react-router';
import { hideFilterOptions } from '../../helpers/filter-options';
import { parsePath } from '../../helpers/parsers';

export function handleEntryPoint(
  entryPoint: string,
  win: { location?: { hash?: string } } = window,
) {
  return async dispatch => {
    const currentPoint = win?.location?.hash.replace(/^#/, '');
    if (entryPoint && parsePath(entryPoint) !== parsePath(currentPoint)) {
      hideFilterOptions();
      await dispatch(replace(entryPoint));
    }
  };
}
